/** ثوابت فئة «قطع غيار السيارات» — متزامنة مع lib/constants/car_spare_parts_constants.dart */

export const CAR_SPARE_PARTS_CONDITIONS = ['جديد', 'إستيراد'] as const

export const CAR_SPARE_PARTS_BRANDS = [
  'اسبرانزا',
  'اوبل',
  'اودي',
  'ايسوزو',
  'ام جي',
  'إنفينيتي',
  'بروتون',
  'بريليانس',
  'بي ام دبليو',
  'بيجو',
  'بي واي دي',
  'تاتا',
  'تويوتا',
  'جاك',
  'جاكوار',
  'جيب',
  'جيتور',
  'جريت وول',
  'جيلي',
  'داسيا',
  'دايو',
  'دايهاتسو',
  'دفسك',
  'دودج',
  'رينو',
  'زوتي',
  'سايبا',
  'سانج يونج',
  'سوبارو',
  'سوزوكي',
  'سيات',
  'سيتروين',
  'سكودا',
  'شانجان',
  'شيري',
  'شيفروليه',
  'فاو',
  'فورد',
  'فولفو',
  'فولكس واجن',
  'فيات',
  'فوتون',
  'كرايسلر',
  'كيا',
  'لكزس',
  'لادا',
  'لاند روفر',
  'مازدا',
  'ماهيندرا',
  'مرسيدس',
  'ميتسوبيشي',
  'ميني',
  'نيسان',
  'هافال',
  'هامر',
  'هوندا',
  'هيونداي',
] as const

export const CAR_SPARE_PARTS_SECTIONS = [
  'أجزاء المحرك',
  'العفشة',
  'فتيس ودبرياج',
  'دورة تبريد المحرك',
  'نظام الشكمان',
  'كهرباء وإضاءة',
  'الهيكل الخارجي',
  'ملحقات العجل',
  'كماليات وعدد',
  'الزيوت والسوائل',
  'الصالون والأمان',
  'نظام الوقود',
  'الفلاتر',
  'اضافات ومنظفات',
  'دورة التكييف',
  'الفرامل',
  'البوجيهات والمباين',
  'السيور والبلي',
] as const

export type CarSparePartsSpecialization = {
  conditions: string[]
  brands: string[]
  sections: string[]
}

function normalize(input: string): string {
  let s = input.toLowerCase().trim()
  s = s
    .replace(/[ًٌٍَُِّْ]/g, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ى/g, 'ي')
    .replace(/ة/g, 'ه')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
  s = s.replace(/[-_،,./\\|]+/g, ' ')
  s = s.replace(/\s+/g, ' ').trim()
  return s
}

export function isCarSparePartsCategoryValue(value: string | undefined | null): boolean {
  const v = normalize(String(value ?? ''))
  if (!v) return false
  if (v.includes('قطع غيار') || v.includes('spare parts') || v.includes('car parts')) {
    return true
  }
  if (
    (v.includes('زيوت') && v.includes('سيارات')) ||
    v.includes('car oil') ||
    v.includes('motor oil')
  ) {
    return true
  }
  return v.includes('car_spare') || v.includes('spare_parts') || v.includes('car_oil')
}

function asStringList(raw: unknown): string[] {
  if (!Array.isArray(raw)) return []
  return raw.map((x) => String(x).trim()).filter(Boolean)
}

export function parseCarSparePartsSpecialization(raw: unknown): CarSparePartsSpecialization | null {
  if (!raw || typeof raw !== 'object') return null
  const obj = raw as Record<string, unknown>
  const conditions = asStringList(obj.conditions)
  const brands = asStringList(obj.brands)
  const sections = asStringList(obj.sections)
  if (conditions.length === 0 && brands.length === 0 && sections.length === 0) return null
  return { conditions, brands, sections }
}
